// extracted by mini-css-extract-plugin
export var phone = "_16-0";